import { supabase } from "@/integrations/supabase/client";

type TurnkeyPublicConfigPayload = {
  organizationId: string | null;
  authProxyConfigId: string | null;
  apiBaseUrl: string | null;
};

/**
 * Loads Turnkey public config from backend runtime secrets into
 * `window.__TURNKEY_PUBLIC_CONFIG__` so the client can use it even when
 * Vite build-time env vars aren't injected.
 */
export async function loadTurnkeyRuntimeConfig(): Promise<void> {
  try {
    const { data, error } = await supabase.functions.invoke<TurnkeyPublicConfigPayload>(
      "turnkey-public-config",
      { method: "GET" }
    );

    if (error || !data) return;
    if (typeof window === "undefined") return;

    if (data.organizationId || data.authProxyConfigId || data.apiBaseUrl) {
      window.__TURNKEY_PUBLIC_CONFIG__ = {
        organizationId: data.organizationId ?? undefined,
        authProxyConfigId: data.authProxyConfigId ?? undefined,
        apiBaseUrl: data.apiBaseUrl ?? undefined,
      };
    }
  } catch {
    // no-op (config will remain unset)
  }
}
